module.exports = __webpack_public_path__ + "media/images/brand/img-vi-2ddc4dfe13556ddca89a54652a7f13f7.svg";